[
    {
        "id":1,      
        "name": "BEBE GESTANTE",
        "acronym": "BG"
    },
    {
        "id":2,
        "name": "CEDULA CIUDADANIA ",
        "acronym": "CC"
    },
    {
        "id":3,
        "name": "CEDULA EXTRANJERIA",
        "acronym": "CE"
    },
    {
        "id":4,
        "name": "PASAPORTE",
        "acronym": "PA"
    },
    {
        "id":5,
        "name": "PERMISO ESPECIAL DE PERMANENCIA",
        "acronym": "PE"
    },
    {
        "id":6,
        "name": "REGISTRO CIVIL DE NACIMIENTO",
        "acronym": "RC"
    },
    {
        "id":7,
        "name": "TARJETA DE IDENTIDAD",
        "acronym": "TI"
    },
    {
        "id":8,
        "name": "PERMISO POR PROTECCION TEMPORAL",
        "acronym": "PT"
    }
]